import React from "react";
import { Box, Typography, Paper, Grid2 } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useLocation } from "react-router-dom";

const ClientIntakeSuccessPage = () => {
  const location = useLocation();
  const submissionCode = location?.state?.submissionCode || "N/A";

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f9fafb"
      px={2}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          display: "flex",
          maxWidth: 1000,
          width: "100%",
        }}
      >
        <Grid2 container spacing={4} alignItems="center">
          <Grid2 size={{ xs: 12, md: 5 }}>
            <img
              src="/client/image.webp"
              alt="Success"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 7 }}>
            <Box display="flex" alignItems="center" mb={2}>
              <CheckCircleIcon
                sx={{
                  color: "green",
                  fontSize: 40,
                  backgroundColor: "#e7f8ed",
                  borderRadius: "50%",
                  padding: "4px",
                  marginRight: 1,
                }}
              />
              <Typography variant="h5" fontWeight={700}>
                Form Submitted Successfully!
              </Typography>
            </Box>

            <Typography variant="body1" gutterBottom>
              Thank you for completing the Cambridge Caregivers intake form.
              Our team will review your information and contact you shortly.
            </Typography>

            <Typography variant="body2" mt={2}>
              <strong>Submission Code:</strong>{" "}
              <span style={{ color: "#333" }}>{submissionCode}</span>
            </Typography>

            <Typography variant="body2" sx={{ color: "green", mt: 2 }}>
              You’ll receive an email copy of the polices and procedure document for your records.
            </Typography>
          </Grid2>
        </Grid2>
      </Paper>
    </Box>
  );
};

export default ClientIntakeSuccessPage;
